<template>
    <div class="related-question"
        v-click-outside="clickOutSideConfig">
        <div class="related-question__list"
            @contextmenu="preventContextMenu">
            <div class="related-question__item"
                v-for="(item, index) in highLightRelatedQuestion"
                :key="index"
                @click="clickItem(index)"
                v-html="item"
                :class="{
                    'is-selected': index === selectedIndex
                }">
            </div>
        </div>
    </div>
</template>

<script>
    // import scrollIntoView from 'scroll-into-view-if-needed'
    export default {
        name: 'TheRelatedQuestion',
        props: {
            relatedQuestion: {
                type: Array,
                required: true,
                validator (value) {
                    return value.every(item => typeof item === 'string')
                }
            },
            keyword: {
                type: String,
                required: true
            }
        },
        data () {
            return {
                selectedIndex: -1,
                clickOutSideConfig: {
                    handler: () => {
                        this.$emit('clearRelatedQuestion')
                    },
                    events: ['click']
                }
            }
        },
        computed: {
            highLightRelatedQuestion () {
                const keyword = this.keyword
                return this.relatedQuestion.map(item => {
                    if (item.includes(keyword)) {
                        return item.replace(keyword, `<strong>${keyword}</strong>`)
                    }
                    return item
                })
            },
            disableChangeSelectedIndex () {
                return this.relatedQuestion.length === 0
            }
        },
        watch: {
            keyword () {
                this.selectedIndex = -1
            }
        },
        methods: {
            /**
             * @returns { Boolean } return selectedIndex !== -1
             */
            setTypingContentIfSelected () {
                if (this.selectedIndex !== -1) {
                    this.setTypingContent(this.selectedIndex)
                    this.selectedIndex = -1
                    return true
                }
                return false
            },
            clickItem (index) {
                this.setTypingContent(index)
                this.$emit('clearRelatedQuestion')

                if (this.$eventBus.isDesktop) {
                    this.$emit('focusIfBlur')
                }
            },
            setTypingContent (index) {
                this.$emit('setTypingContent', this.relatedQuestion[index])
            },
            preventContextMenu (event) {
                event.preventDefault()
            },
            prev () {
                if (this.disableChangeSelectedIndex) {
                    return
                }
                if (this.selectedIndex <= 0) {
                    this.selectedIndex = this.relatedQuestion.length - 1
                } else {
                    this.selectedIndex--
                }
                this.scrollIntoView()
            },
            next () {
                if (this.disableChangeSelectedIndex) {
                    return
                }
                if (this.selectedIndex >= this.relatedQuestion.length - 1) {
                    this.selectedIndex = 0
                } else {
                    this.selectedIndex++
                }
                this.scrollIntoView()
            },
            scrollIntoView () {
                const selectedItemDom = document.querySelectorAll('.related-question__item')[this.selectedIndex]
                if (selectedItemDom) {
                    /**
                     * 等价于 scrollIntoViewIfNeeded，但 smoothscroll-polyfill 认为该方法未纳入标准，故不支持
                     * 为了考虑最大兼容性，改用以下方法
                     * https://github.com/iamdustan/smoothscroll/issues/31#issuecomment-446724252
                     */
                    // scrollIntoView(selectedItemDom, {
                    //     scrollMode: 'if-needed',
                    //     block: 'nearest'
                    // })
                    try {
                        selectedItemDom.scrollIntoViewIfNeeded()
                    } catch (err) {
                        selectedItemDom.scrollIntoView()
                    }

                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .related-question {
        background-color: #fff;
        z-index: 1002;
        box-shadow: 0 -2px 10px #eee;

        &__list {
            background-color: #FAFAFA;

            @include desktop {
                max-height: (40px * 3.5);
                overflow: auto;

                &::-webkit-scrollbar-thumb {
                    background: rgba(0, 0, 0, .3);
                }
            }
        }

        &__item {
            position: relative;
            font-size: 14px;
            line-height: (40 / 14);
            color: #333;
            padding: 0 15px;
            cursor: pointer;
            user-select: none;
            @include text-line;
            &:hover, &:active {
                background-color: #ededed;
            }

            &::before {
                content: '';
                position: absolute;
                top: 0;
                left: 15px;
                right: 15px;
                height: 1px;
                background-color: #E6E6E6;
            }

            &:first-child {
                &::before {
                    left: 0;
                    right: 0;
                }
            }

            /deep/ strong {
                color: #f26130;
                font-weight: 400;
            }

            &.is-selected {
                color: #fff;
                background-color: $primary-color;

                &:before {
                    content: none;
                }

                /deep/ strong {
                    color: #fff;
                }
            }
        }
    }
</style>
